import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

type Props = {
  icon: string;
  color: string;
  onComplete: () => void;
};

const FloatingReaction: React.FC<Props> = ({ icon, color, onComplete }) => {
  const randomX = Math.random() * 80 - 40; // drift left/right

  return (
    <motion.div
      initial={{ opacity: 1, y: 0, scale: 1 }}
      animate={{ opacity: 0, y: -80, x: randomX, scale: 1.6 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      onAnimationComplete={onComplete}
      className={`absolute bottom-0 left-1/2 -translate-x-1/2 pointer-events-none ${color}`}
    >
      <Icon icon={icon} className="w-8 h-8" />
    </motion.div>
  );
};

export default FloatingReaction;
